export function registerComponent(name: string, component: unknown) {
    const runtime = globalThis as typeof globalThis & {
        VGR?: {
            Components?: Record<string, unknown>;
        };
    };

    runtime.VGR = runtime.VGR || {};
    runtime.VGR.Components = runtime.VGR.Components || {};
    runtime.VGR.Components[name] = component;
}